import * as React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';

import styles from './HeadMessage.module.scss';

export const HeadMessage = props => {
  const { account_name, user_name, account_id, action_name } = props.data;
  const { account_number } = props.data.details;
  const request_name = action_name.replace(/ /g, '_').toLowerCase();

  return (
    <div className={styles['head-message']}>
      <Trans i18nKey={'general:sent_requests.review_of_' + request_name}>
        <Link to={`/accounts/${account_id}`}>
          {account_name}
          {account_number}
        </Link>
        {user_name}
      </Trans>
    </div>
  );
};

HeadMessage.propTypes = {
  data: PropTypes.object.isRequired,
};
